export const normalizeId = (value) =>
  value === null || value === undefined ? '' : String(value);

export const idsEqual = (left, right) =>
  normalizeId(left) === normalizeId(right);
